<template>
  <div class="container">
    <HeadingOne class="-margin-md">口座のご登録</HeadingOne>

    <WizardGroup class="-margin-md">
      <MainWizard :active-index="2" type="entry"></MainWizard>
    </WizardGroup>

    <NoticeBox class="-error">
      <NoticeHeader>
        <h2 class="heading">ご指定の口座はご登録いただけません。</h2>
      </NoticeHeader>
      <NoticeBody
        >誠に申し訳ございませんが、「口座のご登録へ戻る」を押して、改めて口座をご登録いただくか、その他のお手続きをご選択いただきご本人さま確認書類をご提出してください。</NoticeBody
      >
    </NoticeBox>

    <BtngroupSingle class="-margin-lg">
      <BtnBack class="-back -md" router-name="en006" :query="{ state: '2' }">
        口座のご登録へ戻る
      </BtnBack>
    </BtngroupSingle>
  </div>
</template>

<script>
import { setMeta } from "@/utils/Meta";
import HeadingOne from "@/components/heading/HeadingOne";
import WizardGroup from "@/components/wizard/WizardGroup";
import MainWizard from "@/components/wizard/MainWizard";
import NoticeBox from "@/components/box/NoticeBox";
import NoticeHeader from "@/components/box/NoticeHeader";
import NoticeBody from "@/components/box/NoticeBody";
import BtngroupSingle from "@/components/button/BtngroupSingle";
import BtnBack from "@/components/button/BtnBack";
export default {
  name: "Tem003",
  components: {
    BtnBack,
    BtngroupSingle,
    NoticeBody,
    NoticeHeader,
    NoticeBox,
    MainWizard,
    WizardGroup,
    HeadingOne,
  },
  setup() {
    setMeta({
      title: "口座のご登録",
      description:
        "au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。",
      keywords:
        "au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,入会,口座登録",
    });
  },
  data() {
    return {};
  },
};
</script>

<style scoped></style>
